"use strict";
// The user aborted a request - CHROME
// The operation was aborted - MOZILLA
// Fetch is aborted - SAFARI
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIsAbortRequestError = void 0;
var getIsAbortRequestError = function (message) {
    return /(The user aborted a request)|(The operation was aborted)|(Fetch is aborted)/.test(message);
};
exports.getIsAbortRequestError = getIsAbortRequestError;
